export default __webpack_public_path__ + "static/media/companyBackground.2574e58e.png";